import React, { useState } from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import tw, { css } from 'twin.macro'
import { X, Check, ChevronDown, ChevronUp } from 'react-feather'
import EcoSwimv2img from '../../images/Ecoswim_Carton+ControlUnit+Chlorinator.png'
export default ({ mineralSwimProducts, id, style, handleSelectProduct, selectedProducts }) => {
	const [specOpen, setSpecOpen] = useState(false)
	const [featOpen, setFeatOpen] = useState(false)
	const [warOpen, setWarOpen] = useState(false)
	const [upgOpen, setUpgOpen] = useState(false)
	return (
		<>
			<p tw="text-xl bg-gray-200 mx-2 my-3 p-2 md:hidden">Ecoswim™️</p>
			<div tw="overflow-scroll md:overflow-hidden">
				<table id={id} css={style}>
					<caption>Ecoswim&trade;</caption>
					<thead>
						<tr>
							<th tw="align-bottom text-left md:!text-right" scope="col">
								Maytronics Water <br />
								Treatment Product
							</th>
							<th scope="col" tw="text-center">
									<div>
										<img src={EcoSwimv2img} alt="Mineral Swim™️ Pro20"/>
									</div>
									Ecoswim® ES35
								</th>
							<th scope="col" tw="text-center">
									<div>
										<img src={EcoSwimv2img} alt="Mineral Swim™️ Pro20"/>
									</div>
									Ecoswim® ES25
								</th>
								<th scope="col" tw="text-center">
									<div>
										<img src={EcoSwimv2img} alt="Mineral Swim™️ Pro20"/>
									</div>
									Ecoswim® ES20
								</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td
								tw="font-semibold"
								scope="row"

							>
								PRODUCT CODE
							</td>
							<td >10-110-0004</td>
							<td >10-110-0003</td>
							<td >10-110-0002</td>
						</tr>
						<tr>
							<td
								tw="font-semibold"
								scope="row"

							>
								RRP
							</td>
							<td >$2,615</td>
							<td >$2,380</td>
							<td >$2,140</td>
						</tr>
						<tr
							tw="cursor-pointer"
							onClick={() => setSpecOpen((prevState) => !prevState)}
							className="trow-title"
						>
							<td
								tw="cursor-pointer font-medium bg-white py-4 uppercase text-lg border-t-2 border-b-2 border-t-gray-400 border-b-gray-400"
								scope="row"
							>
								Specifications
								{specOpen ? (
									<ChevronUp tw="inline-block ml-2 self-center" />
								) : (
									<ChevronDown tw="inline-block ml-2 self-center" />
								)}
							</td>
							<td tw="md:bg-white" colSpan="3" />
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Recommended Max Poolsize
							</td>
							<td >up to 100,000 L</td>
							<td >up to 80,000 L</td>
							<td >up to 60,000 L</td>
							{/* <td>
					{mineralSwimProducts[1].specifications[0].detail.split(' —')[0]}
				</td>
				<td>
					{mineralSwimProducts[2].specifications[0].detail.split(' —')[0]}
				</td>
				<td>
					{mineralSwimProducts[3].specifications[0].detail.split(' —')[0]}
				</td>
				<td>
					{mineralSwimProducts[0].specifications[0].detail.split(' —')[0]}
				</td> */}
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
							Nominal Chlorine Output
							</td>
							<td >33 G/HR + Ozone</td>
							<td >26 G/HR + Ozone</td>
							<td >20 G/HR + Ozone</td>
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Ozone Purification
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td><td>
								<X tw="mx-auto md:mx-auto" />
							</td><td>
								<X tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Mineral/Salt Chlorinator
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
							Modular system with Future Module Upgrades Available
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
							Hand-Held Controller
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
							Generator Module
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
							Purifier Module
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Additional Chlorinator Required
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Compatible with Mineral Swim&trade; Dead Sea Minerals
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Operating Modes
							</td>
							<td >Standard / Eco / Boost Mode</td>
							<td >Standard / Eco / Boost Mode</td>
							<td >Standard / Eco / Boost Mode</td>
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Operating TDS Level
							</td>
							<td >3500-6500 ppm</td>
							<td >3500-6500 ppm</td>
							<td >3500-6500 ppm</td>
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Installation Time
							</td>
							<td>&lt; 1 hour</td>
							<td>&lt; 1 hour</td>
							<td>&lt; 1 hour</td>
						</tr>
						{/* <tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Professional Pool Side Health Checks
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
						</tr> */}
						{/* <tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Mineral Swim&trade; Welcome Pack
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Ecoclear&reg; Shield & Swim, 3 in 1 Pool Water Optimiser
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
						</tr> */}
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Made in Australia
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr
							tw="cursor-pointer"
							onClick={() => setFeatOpen((prevState) => !prevState)}
							className="trow-title"
						>
							<td
								tw="cursor-pointer font-medium bg-white py-4 uppercase text-lg border-t-2 border-b-2 border-t-gray-400 border-b-gray-400"
								scope="row"
							>
								Features
								{featOpen ? (
									<ChevronUp tw="inline-block ml-2 self-center" />
								) : (
									<ChevronDown tw="inline-block ml-2 self-center" />
								)}
							</td>
							<td tw="md:bg-white" colSpan="3" />
						</tr>
						<tr css={[!featOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Dual Chlorine & Ozone Sanitation
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!featOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Healthy Pool Water Purification
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!featOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Allergy, Asthma & Eczema Friendly
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!featOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Reduced Chlorine & Chemical Usage
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!featOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Chloramine Removal
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!featOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Safe Sanitation By-Products
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!featOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Reduced Eye Irritation
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
						</tr>

						<tr
							tw="cursor-pointer"
							onClick={() => setWarOpen((prevState) => !prevState)}
							className="trow-title"
						>
							<td
															tw="cursor-pointer font-medium bg-white py-4 uppercase text-lg border-t-2 border-b-2 border-t-gray-400 border-b-gray-400"
															scope="row"
														>
																			<div>
															<p>Warranty</p>
															<p tw='text-xs normal-case text-gray-700' >For full T&Cs refer to the manual</p>
															</div>

														</td>
							<td tw="align-middle">5 years limited</td>
							<td tw="align-middle">5 years limited</td>
							<td tw="align-middle">5 years limited</td>
						</tr>
						{/* <tr css={[!warOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								System (control box, electronics, seals)
							</td>
							<td>5 years (3 years full + 2 years pro rata)</td>
							<td>5 years (3 years full + 2 years pro rata)</td>
							<td>5 years (3 years full + 2 years pro rata)</td>
						</tr>
						<tr css={[!warOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Ozone Cell
							</td>
							<td>-</td>
							<td>-</td>
							<td>-</td>
						</tr>
						<tr css={[!warOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Electrolyic Cell
							</td>
							<td>5 years (3 years full + 2 years pro rata)</td>
							<td>5 years (3 years full + 2 years pro rata)</td>
							<td>5 years (3 years full + 2 years pro rata)</td>
						</tr> */}

						<tr
							tw="cursor-pointer"
							onClick={() => setUpgOpen((prevState) => !prevState)}
							className="trow-title"
						>
							<td
								tw="cursor-pointer font-medium bg-white py-4 uppercase text-lg border-t-2 border-b-2 border-t-gray-400 border-b-gray-400"
								scope="row"
							>
								Upgrades
								{upgOpen ? (
									<ChevronUp tw="inline-block ml-2 self-center" />
								) : (
									<ChevronDown tw="inline-block ml-2 self-center" />
								)}
							</td>
							<td tw="md:bg-white" colSpan="3" />
						</tr>
						<tr css={[!upgOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								pH Drive Series
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!upgOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Mineral Swim&trade; 100% Dead Sea Minerals
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!upgOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
							Upgrade to Ozone Purification Available
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr>
							<td >
							</td>
							<td className='bg-white'>
								<a href={`https://www.maytronics.com.au/product/ecoswim-es35/`} target='_blank' rel='noopener noreferrer'><button className='font-semibold whitespace-nowrap inline-flex items-center justify-center px-4 py-1 border border-transparent rounded shadow-sm bg-blue-500 hover:bg-blue-400 text-white hover:text-gray-800'>BUY NOW </button></a>
							</td>
							<td className='bg-white'>
								<a href={`https://www.maytronics.com.au/product/ecoswim-es25/`} target='_blank' rel='noopener noreferrer'><button className='font-semibold whitespace-nowrap inline-flex items-center justify-center px-4 py-1 border border-transparent rounded shadow-sm bg-blue-500 hover:bg-blue-400 text-white hover:text-gray-800'>BUY NOW </button></a>
							</td>
							<td className='bg-white'>
								<a href={`https://www.maytronics.com.au/product/ecoswim-es20/`} target='_blank' rel='noopener noreferrer'><button className='font-semibold whitespace-nowrap inline-flex items-center justify-center px-4 py-1 border border-transparent rounded shadow-sm bg-blue-500 hover:bg-blue-400 text-white hover:text-gray-800'>BUY NOW </button></a>
							</td>
						</tr>
						<tr>
							<td></td>
							<td  className='bg-white space-x-2'>
							<div className='flex justify-center items-center gap-2'>
							<input type="checkbox" id="e2checkbox1" name="e2checkbox1" className='cursor-pointer' style={{width: '20px', height: '20px', transform: 'scale(1.1)'}} onChange={()=>handleSelectProduct("Ecoswim® ES35")} checked={selectedProducts.includes("Ecoswim® ES35")}/>
							<label for="e2checkbox1" className='cursor-pointer'>Compare</label>
							</div>
							</td>
							<td  className='bg-white space-x-2'>
							<div className='flex justify-center items-center gap-2'>
							<input type="checkbox" id="e2checkbox2" name="e2checkbox2" className='cursor-pointer' style={{width: '20px', height: '20px', transform: 'scale(1.1)'}} onChange={()=>handleSelectProduct("Ecoswim® ES25")} checked={selectedProducts.includes("Ecoswim® ES25")}/>
							<label for="e2checkbox2" className='cursor-pointer'>Compare</label>
							</div>
							</td>
							<td  className='bg-white space-x-2'>
							<div className='flex justify-center items-center gap-2'>
							<input type="checkbox" id="e2checkbox3" name="e2checkbox3" className='cursor-pointer' style={{width: '20px', height: '20px', transform: 'scale(1.1)'}} onChange={()=>handleSelectProduct("Ecoswim® ES20")} checked={selectedProducts.includes("Ecoswim® ES20")}/>
							<label for="e2checkbox3" className='cursor-pointer'>Compare</label>
							</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</>
	)
}
